import { Injectable } from '@angular/core'
import { IModelBase } from 'common-components'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface IAddress extends IModelBase {
  Address1: string
  Address2: string
  ZipCode: string
  CityName: string
  StateId: number
  CountryId: number
}

@Injectable()
export class PayerAddressODataService extends ODataService<IAddress> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'PayerAddresses'
  }
}

@Injectable()
export class ProviderAddressODataService extends ODataService<IAddress> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'ProviderAddresses'
  }
}
